import { doDefaultFetch } from '@nhl/fetch-helpers';

const fetchComponentSeasons = args => {
    return doDefaultFetch('/site/api/component-season', args);
};

const findComponentSeasonForComponent = (component, componentSeasons) => {
    return componentSeasons.find(
        componentSeason => componentSeason.id === component
    );
};

export default {
    fetchComponentSeasons,
    findComponentSeasonForComponent
};
